import React from 'react';
import { Route, Routes, Navigate } from 'react-router-dom';
// import { getPageName } from '../helpers/utils';
import loadable from '@loadable/component';

import BugZeroLayout from './BugZeroLayout';
import PageContent from './PageContent';
// import ErrorLayout from './ErrorLayout';
import AuthBasicLayout from './AuthBasicLayout';
import ProductGuard from '../components/bz/ProductGuard';

import Dashboard from '../components/dashboard/Dashboard';
import PlatformHome from '../components/page/PlatformHome';
import PlatformSettings from '../components/page/PlatformSettings';
import PredictWatchlist from '../components/page/PredictWatchlist';
import PredictOutcomes from '../components/page/PredictOutcomes';
import PredictSettings from '../components/page/PredictSettings';
import PredictCoverage from '../components/page/PredictCoverage';
import PredictDashboard from '../components/page/PredictDashboard';
import PredictBug from '../components/page/PredictBug';
import PredictModel from '../components/page/PredictModel';
/* integrations */
import IntegrationSettings from '../components/page/IntegrationSettings';
import SSOSettings from '../components/page/SSOSettings';
import OpenApiSettings from '../components/page/OpenApiSettings';
import SplunkSettings from '../components/page/SplunkSettings';

/* managed products */
import ManagedProductListing from '../components/page/ManagedProductListing';
import ManagedProductConfig from '../components/page/ManagedProductConfig';
import ManagedProductEdit from '../components/page/ManagedProductEdit';

/* Admin */
import Firewall from '../components/page/Firewall';
import GlobalAISettings from '../components/page/GlobalAISettings';
/* Support */
import CreateSupportTicket from '../components/page/CreateSupportTicket';
import ViewSupportTickets from '../components/page/ViewSupportTickets';
import SupportTicketDetail from '../components/page/SupportTicketDetail';
import GetHelp from '../components/page/GetHelp';

/* tools */
import BugScrubTool from '../components/page/BugScrubTool';
import PlanReports from '../components/page/PlanReports';

/* dev — hidden style guide (not linked anywhere) */
import StyleGuide from '../components/page/StyleGuide';

/* users */
import ViewUsers from '../components/page/ViewUsers';
import ViewGroups from '../components/page/ViewGroups';
import RBACRoles from '../components/page/RBACRoles';

/* Documentation */
import VendorIntegrationList from '../components/page/VendorIntegrationList';
import VendorIntegrationDetail from '../components/page/VendorIntegrationDetail';
// import KbArticle from '../components/page/KbArticle';
import Profile from '../components/page/Profile';
import Faq from '../components/page/Faq';

// Admin
import SuperAdmin from '../components/page/SuperAdmin';
import VendorHealthStatusPage from '../components/page/VendorHealthStatusPage';
import RunRequirementsPage from '../components/page/RunRequirementsPage';

// Authentication
import Login from '../components/auth/basic/Login';
import Logout from '../components/auth/basic/Logout';
import Forbidden from '../components/auth/basic/Forbidden';
// import Registration from '../components/auth/basic/Registration';
import ForgetPassword from '../components/auth/basic/ForgetPassword';
import PasswordReset from '../components/auth/basic/PasswordReset';
import ConfirmMail from '../components/auth/basic/ConfirmMail';
// import LockScreen from '../components/auth/basic/LockScreen';
import Error404 from '../components/errors/Error404';
// import DashboardLayout from './DashboardLayout';
// const AuthBasicLayout = loadable(() => import('./AuthBasicLayout'));
const AuthCardRoutes = loadable(() => import('../components/auth/card/AuthCardRoutes'));
const AuthSplitRoutes = loadable(() => import('../components/auth/split/AuthSplitRoutes'));

const Layout = () => {
  // const { isFluid, isVertical, navbarStyle } = useContext(AppContext);
  // let location = useLocation();

  // useEffect(() => {
  //   console.log('dash layout');
  //   console.log('location', location.pathname);
  //   window.scrollTo(0, 0);
  // }, []);
  return (
    <div>
      <Routes>
        {/* Main Layout — new BugZero shell (Direction A, workspace switcher) */}
        <Route element={<BugZeroLayout />}>
          {/* New design pages — manage their own layout/padding (some full-bleed) */}
          <Route path="/" element={<PlatformHome />} />
          <Route path="platform" element={<Navigate to="/" replace />} />
          <Route path="platform/:section" element={<PlatformSettings />} />
          <Route
            path="prevent"
            element={
              <ProductGuard product="prevent">
                <Dashboard />
              </ProductGuard>
            }
          />
          <Route
            path="prevent/run-requirements"
            element={
              <ProductGuard product="prevent">
                <RunRequirementsPage />
              </ProductGuard>
            }
          />
          <Route
            path="predict"
            element={
              <ProductGuard product="predict">
                <PredictDashboard />
              </ProductGuard>
            }
          />
          <Route
            path="predict/outcomes"
            element={
              <ProductGuard product="predict">
                <PredictOutcomes />
              </ProductGuard>
            }
          />
          <Route
            path="predict/settings"
            element={
              <ProductGuard product="predict">
                <PredictSettings />
              </ProductGuard>
            }
          />
          <Route
            path="predict/coverage"
            element={
              <ProductGuard product="predict">
                <PredictCoverage />
              </ProductGuard>
            }
          />
          <Route
            path="predict/watch"
            element={
              <ProductGuard product="predict">
                <PredictWatchlist />
              </ProductGuard>
            }
          />
          <Route
            path="predict/watch/:vendor/:bugId"
            element={
              <ProductGuard product="predict">
                <PredictBug />
              </ProductGuard>
            }
          />
          <Route
            path="predict/model"
            element={
              <ProductGuard product="predict">
                <PredictModel />
              </ProductGuard>
            }
          />

          {/* Legacy / ported pages — wrapped in the standard padded content area */}
          <Route element={<PageContent />}>
            {/* Hidden dev route — design-system catalogue, not linked anywhere */}
            <Route path="style-guide" element={<StyleGuide />} />

            {/* Plan — formerly /tools/bug-scrub-advisor */}
            <Route
              path="plan"
              element={
                <ProductGuard product="plan">
                  <BugScrubTool />
                </ProductGuard>
              }
            />
            {/* STRY0038480: declared before plan/:projectId so the static
                segment is unambiguous (React Router v6 also ranks static
                above dynamic, so this is belt-and-braces). */}
            <Route
              path="plan/reports"
              element={
                <ProductGuard product="plan">
                  <PlanReports />
                </ProductGuard>
              }
            />
            <Route
              path="plan/:projectId"
              element={
                <ProductGuard product="plan">
                  <BugScrubTool />
                </ProductGuard>
              }
            />
            <Route
              path="plan/:projectId/:versionId"
              element={
                <ProductGuard product="plan">
                  <BugScrubTool />
                </ProductGuard>
              }
            />

            {/* Admin routes */}
            <Route path={'super-admin'} element={<SuperAdmin />} />
            <Route path={'super-admin/:section'} element={<SuperAdmin />} />

            {/* Vendor routes */}
            <Route path={'vendors/:vendorId'} element={<Navigate to="configuration" replace />} />
            <Route path={'vendors/:vendorId/configuration'} element={<ManagedProductConfig />} />
            <Route path={`vendors/:vendorId/products/`} element={<ManagedProductListing />} />
            <Route path={`vendors/:vendorId/products/new`} element={<ManagedProductEdit />} />
            <Route
              path={`vendors/:vendorId/products/:managedProductId/:managedProductName`}
              element={<ManagedProductEdit />}
            />

            {/* Platform-level config — elevated from the Prevent context (STRY0038565).
                Existing working components, re-parented under /platform/*. */}
            <Route path="platform/members" element={<ViewUsers />} />
            <Route path="platform/members/groups" element={<ViewGroups />} />
            <Route path="platform/members/roles" element={<RBACRoles />} />
            <Route path="platform/sso" element={<SSOSettings />} />
            <Route path="platform/integrations" element={<IntegrationSettings />} />
            <Route path="platform/integrations/api" element={<OpenApiSettings />} />
            <Route path="platform/integrations/splunk" element={<SplunkSettings />} />
            <Route path="platform/firewall" element={<Firewall />} />
            <Route path="platform/globalai" element={<GlobalAISettings />} />
            <Route path="platform/source-health" element={<VendorHealthStatusPage />} />

            {/* Redirects — old Prevent-context config paths → elevated /platform/* homes */}
            <Route path="integrations/servicenow" element={<Navigate to="/platform/integrations" replace />} />
            <Route path="integrations/sso" element={<Navigate to="/platform/sso" replace />} />
            <Route path="integrations/bugzero-api" element={<Navigate to="/platform/integrations/api" replace />} />
            <Route
              path="integrations/logging/splunk"
              element={<Navigate to="/platform/integrations/splunk" replace />}
            />
            <Route path="users/view-users" element={<Navigate to="/platform/members" replace />} />
            <Route path="users/view-groups" element={<Navigate to="/platform/members/groups" replace />} />
            <Route path="users/view-roles" element={<Navigate to="/platform/members/roles" replace />} />
            <Route path="admin/firewall" element={<Navigate to="/platform/firewall" replace />} />
            <Route path="admin/global-ai" element={<Navigate to="/platform/globalai" replace />} />
            <Route path="vendor-health" element={<Navigate to="/platform/source-health" replace />} />

            {/* User routes */}
            <Route path="profile" element={<Profile />} />

            {/* Documentation routes */}
            {/* <Route path="documentation/kb-articles" element={<KbArticle />} /> */}
            <Route path="documentation/:category" element={<VendorIntegrationList />} />
            <Route path="documentation/:slug/:slug" element={<VendorIntegrationDetail />} />
            <Route path="pages/faq" element={<Faq />} />

            {/* Support routes */}
            <Route path="support/create-ticket" element={<CreateSupportTicket />} />
            <Route path="support/view-tickets" element={<ViewSupportTickets />} />
            <Route path="support/view-tickets/:id" element={<SupportTicketDetail />} />
            <Route path="support/get-help" element={<GetHelp />} />
          </Route>

          {/* 404 — bare (Error404 is a full-screen centered layout) */}
          <Route path="*" element={<Error404 />} />
        </Route>

        <Route path="authentication/card" element={<AuthCardRoutes />} />
        <Route path="authentication/split" element={<AuthSplitRoutes />} />
        {/* <Route path="/authentication/wizard" element={WizardLayout} /> */}
        {/* <Route path="errors" element={<ErrorLayout />} /> */}
        <Route path="authentication/" element={<AuthBasicLayout />}>
          <Route path={`login`} element={<Login />} />
          <Route path={`logout`} element={<Logout />} />
          <Route path={`forbidden`} element={<Forbidden />} />
          {/* <Route path={`register`} element={<Registration />} /> */}
          <Route path={`forget-password`} element={<ForgetPassword />} />
          <Route path={`confirm-mail`} element={<ConfirmMail />} />
          <Route path={`password-reset`} element={<PasswordReset />} />
          {/* <Route path={`lock-screen`} element={<LockScreen />} /> */}
        </Route>
      </Routes>
    </div>
  );
};

export default Layout;
